import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, Routes, Route } from "react-router-dom"; // Import Routes and Route
import AppLayout from "../../component/Sidebar/SideMenu";
import Home from "../Home/Home";
import UserManagement from "../UserMangement/UserManagement";
import ApiScraperSettings from "../ApiSettings/ApiSetting";
import Subscription from "../Subscription/Subscription";
import Analytics from "../Analytics/Analytics";
import Settings from "../Settings/Settings";
import PrivacyPolicy from "../PrivacyPolicy/PrivacyPolicy";
import TemsAndConsition from "../TemsAndConsition/TemsAndConsition";



const HomePage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const getActiveFromPath = (pathname) => {
    switch (pathname) {
      case "/dashboard":
        return "Dashboard";
      case "/dashboard/user-management":
        return "User Management";
      case "/dashboard/api-setting":
        return "Api Setting";
      case "/dashboard/subscription":
        return "Subscriptions";
      case "/dashboard/analytics":
        return "Analytics";
      case "/dashboard/settings":
        return "Settings";
      case "/dashboard/privacy-policy":
        return "Privacy Policy";
      case "Terms and Conditions":
        return "Terms and Conditions";
      default:
        return "Dashboard";
    }
  };

  const [active, setActive] = useState(getActiveFromPath(location.pathname));

  useEffect(() => {
    setActive(getActiveFromPath(location.pathname));
  }, [location.pathname]);

// Inside Dashboard.js
const handleSetActive = (item) => {
  setActive(item);
  switch (item) {
    case "Dashboard":
      navigate("/dashboard"); // Absolute path
      break;
    case "User Management":
      navigate("/dashboard/user-management"); // Absolute path
      break;
    case "Api Setting":
      navigate("/dashboard/api-setting"); // Absolute path
      break;
    case "Subscriptions":
      navigate("/dashboard/subscription"); // Absolute path
      break;
    case "Analytics":
      navigate("/dashboard/analytics"); // Absolute path
      break;
    case "Settings":
      navigate("/dashboard/settings"); // Absolute path
      break;
    case "Privacy Policy":
      navigate("/dashboard/privacy-policy"); // Absolute path
      break;
    case "Terms and Conditions":
      navigate("/dashboard/terms-and-conditions"); // Absolute path
      break;
    default:
      navigate("/dashboard");
  }
};

  return (
    <AppLayout active={active} setActive={handleSetActive}>
      {/* Use Routes to render the correct component based on the URL */}
      <Routes>
        <Route index element={<Home />} />
        <Route path="user-management" element={<UserManagement />} />
        <Route path="api-setting" element={<ApiScraperSettings />} />
        <Route path="subscription" element={<Subscription />} />
        <Route path="analytics" element={<Analytics />} />
        <Route path="settings" element={<Settings />} />
        <Route path="privacy-policy" element={<PrivacyPolicy />} />
        <Route path="terms-and-conditions" element={<TemsAndConsition />} />
        <Route path="*" element={<h1>Page Not Found</h1>} />
      </Routes>
    </AppLayout>
  );
};

export default HomePage;